import { Box, Grid, Link, MenuItem, Select, Tab, Tabs } from "@mui/material";
import React, { useEffect } from "react";
import ProductCard from "../components/ProductCard";
import ProductCardLoader from "../components/ProductCardLoader";
import { COMP_STATUSES } from "../shared/utils";
import { loadHomePageData } from "../shared/utils/transform";
import stagingData from "../products/staging.json";
import prodData from "../products/prod.json";
import { createSvgIcon } from "@mui/material/utils";
import { makeStyles } from "@mui/styles";
import { useTheme } from '@mui/material/styles';

import { useMediaQuery } from "@mui/material";
const LocationIcon = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49 11.5803C7.6 11.7203 7.77 11.8003 7.95 11.8003C8.13 11.8003 8.3 11.7203 8.41 11.5803C8.41 11.5803 11.24 8.11031 11.37 7.96031C12.86 6.29031 12.74 3.77031 11.09 2.23031C9.35 0.600312 6.52 0.600312 4.78 2.23031C3.12 3.79031 3.01 6.32031 4.53 7.99031C4.7 8.19031 7.47 11.5803 7.47 11.5803H7.49ZM5.62 3.10031C6.91 1.90031 9 1.90031 10.29 3.10031C11.47 4.21031 11.56 5.96031 10.49 7.16031C10.43 7.23031 8.94 9.05031 7.96 10.2503C6.77 8.79031 5.53 7.27031 5.45 7.18031C4.35 5.98031 4.43 4.22031 5.63 3.09031L5.62 3.10031ZM14.91 12.8903L14.1 10.6303C13.87 9.98031 13.24 9.55031 12.53 9.55031H12.17C11.84 9.55031 11.57 9.82031 11.57 10.1503C11.57 10.4803 11.84 10.7503 12.17 10.7503H12.53C12.73 10.7503 12.91 10.8703 12.97 11.0303L13.77 13.2903C13.82 13.4303 13.77 13.5403 13.72 13.6103C13.63 13.7303 13.49 13.8003 13.32 13.8003H2.66003C2.50003 13.8003 2.35003 13.7303 2.26003 13.6103C2.21003 13.5403 2.17003 13.4303 2.21003 13.2903L3.01003 11.0303C3.07003 10.8703 3.23003 10.7603 3.43003 10.7503C3.76003 10.7303 4.01003 10.4503 4.00003 10.1203C3.99003 9.79031 3.70003 9.55031 3.37003 9.55031C2.69003 9.59031 2.11003 10.0103 1.89003 10.6303L1.09003 12.8903C0.920029 13.3703 0.990029 13.8803 1.29003 14.3003C1.60003 14.7403 2.12003 15.0003 2.67003 15.0003H13.34C13.89 15.0003 14.41 14.7403 14.72 14.3003C15.01 13.8803 15.09 13.3703 14.92 12.8903H14.91ZM9.60003 5.2503C9.60003 6.1303 8.88002 6.8503 8.00002 6.8503C7.12002 6.8503 6.40002 6.1303 6.40002 5.2503C6.40002 4.3703 7.12002 3.6503 8.00002 3.6503C8.88002 3.6503 9.60003 4.3703 9.60003 5.2503ZM8.40002 5.2503C8.40002 5.0303 8.22002 4.8503 8.00002 4.8503C7.78002 4.8503 7.60002 5.0303 7.60002 5.2503C7.60002 5.4703 7.78002 5.6503 8.00002 5.6503C8.22002 5.6503 8.40002 5.4703 8.40002 5.2503Z"
      fill="#264966"
    />
  </svg>,
  "Location"
);
export const Home = () => {
  const theme = useTheme();
  const welcome = {
    paddingTop: "42px",
    paddingBottom: "12px",
    fontWeight: "800",
    fontSize: "40px",
    color: "#FFFFFF",
    "@media (max-width: 992px)": {
      fontSize: "23px",
      lineHeight: "26px",
    },
  };

  const looking = {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    width: "calc(55% - 16px)",
    "@media (max-width: 992px)": {
      width: "85%",
    },
  };

  const prodCard = {
    minHeight: "75px",
  };

  const topBox = {
    color: "#27313A",
    maxWidth: "calc(100vw - 25%)",
    padding: "7px 0",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 992px)": {
      maxWidth: "calc(100vw - 10%)",
    },
  };

  const getStatus = (res) => {
    const statusArr: any = [];
    let status: any;
    res.components.forEach((item) => {
      statusArr.push(item.status);
    });

    const total = statusArr.length;
    const isMO = statusArr.filter((a) => a === "MO").length;
    const isPO = statusArr.filter((a) => a === "PO").length;
    const isPD = statusArr.filter((a) => a === "PD").length;
    const isUM = statusArr.filter((a) => a === "UM").length;
    if (isMO === total) {
      status = "Major Outage";
    } else if (isPO === total) {
      status = "Partial Outage";
    } else if (isPD === total) {
      status = "Degraded Performance";
    } else if (isUM === total) {
      status = "Under Maintenance";
    } else if (statusArr.find((a) => a === "MO")) {
      status = "Partial Outage";
    } else if (statusArr.find((a) => a === "PO")) {
      status = "Partial Outage";
    } else if (statusArr.find((a) => a === "PD")) {
      status = "Degraded Performance";
    } else if (statusArr.find((a) => a === "UM")) {
      status = "Under Maintenance";
    } else if (res.liveIncidents && res.liveIncidents.length) {
      status = "Partial Outage";
    } else if (res.onGoingMaintenance && res.onGoingMaintenance.length) {
      status = "Under Maintenance";
    } else {
      status = "Operational";
    }
    return status;
  };
  let productsData: any = prodData;
  const [products, setProdData] = React.useState(productsData);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [showNoMaintenance, setShowNoMaintenance] = React.useState(false);
  const [currentIncidentTab, setCurrentIncidentTab] = React.useState("status");
  const [filteredProductsData, setFilteredProductsData] = React.useState([]);
  useEffect(() => {
    async function fetchData() {
      let updatedProducts;
      await products.forEach(async (account) => {
        await loadHomePageData(account.freshStatusAccountNumber).then(
          (response) => {
            updatedProducts = products.map((prod: any) => {
              if (prod.name === account.name) {
                prod.status = getStatus(response);
                prod.data = response;
                prod.scheduledInc = [
                  ...response.plannedIncidents,
                  ...response.onGoingMaintenance,
                ];
               prod.scheduledInc = prod.scheduledInc.filter(maintenance => {
                const endTime = new Date(maintenance.end_time).getTime();
                const currentTime = new Date().getTime();
                return endTime > currentTime;
              });
              }
              return prod;
            });
            updatedProducts = updatedProducts.sort((a, b) => {
              return (
                b.data?.liveIncidents?.length +
                b?.scheduledInc?.length -
                (a.data?.liveIncidents?.length + a?.scheduledInc?.length)
              );
            });
            setProdData(updatedProducts);
            setFilteredProductsData(updatedProducts);
          }
        );
      });
    }
    fetchData();
  }, []);
  function sumArrayWithZeroForNonNumeric(arr) {
    let sum = 0;

    for (let i = 0; i < arr.length; i++) {
      const num = parseFloat(arr[i]);

      if (!isNaN(num)) {
        sum += num;
      } else {
        // Treat non-numeric values as zero
        sum += 0;
      }
    }

    return sum;
  }
  useEffect(() => {
    if (products.every((prod: any) => prod.status)) {
      setShowNoMaintenance(
        sumArrayWithZeroForNonNumeric(
          products.map((prod: any) => prod.currentScheduledIncLength)
        ) === 0
          ? true
          : false
      );
    }
  }, [products]);
  useEffect(() => {
    if (products.every((prod: any) => prod.status)) {
      setShowNoMaintenance(false);
    }
  }, [currentTab]);

  const banner = {
    //height: "265px",
    background: "url(/background.webp) repeat",
    backgroundSize: "cover",
    paddingTop: "5px",
  };
  const useStyles = makeStyles({
    tab: {
      padding: "0px 0px 20px 0px",
      "& .MuiTabs-indicator": {
        backgroundColor: "none",
      },
      "& .MuiTab-root": {
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "none",
        },
        "&.Mui-selected": {
          color: "#FFFFFF",
          background: "#4E5D59",
          borderRadius: "6px",
        },
      },
    },
    regionDropdown: {
      height: "36px",
      background: "#FFFFFF",
      borderRadius: "6px",
      margin: "10px 0 10px 0",
    },
  });
  const classes = useStyles();

  const bannerImage = {
    marginTop: "40px",
    background: "url(/banner.webp)",
    backgroundRepeat: "no-repeat",
    width: "100%",
    [theme.breakpoints.down('md')]: {
      display: 'none', // Adjust visibility or content for smaller screens
    },
    // backgroundSize: "75% 60%",
    "@media (max-width: 992px)": {
      background: "url(/banner.webp)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "calc(100vw - 10%) 156px",
      height: "156px",
    },
  };
  const lPage = {
    marginLeft: "auto",
    marginRight: "auto",
    height: "434px",
    maxWidth: "calc(100vw - 25%)",
    "@media (max-width: 992px)": {
      height: "380px",
      maxWidth: "calc(100vw - 10%)",
    },
  };

  const pullup = {
    zIndex: 999,
    position: "relative",
    bottom: "150px",
    "@media (max-width: 992px)": {
      bottom: "140px",
    },
  };

  const lpageProducts = {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "calc(100vw - 25%)",
    "@media (max-width: 992px)": {
      maxWidth: "calc(100vw - 10%)",
    },
  };

  const getIconUrl = (eachInc, id) => {
    const component = eachInc.affected_components.find(
      (comp) => comp.component === id
    );
    const state: any = {};
    if (!component) {
      // check if the BarChart is for group
      eachInc.affected_components.forEach((comp) => {
        state[comp.new_status] = comp.new_status;
      });
      return COMP_STATUSES[
        state.MO || state.PO || state.PD || state.UM || state.OP || ""
      ].iconUrl;
    }
    return COMP_STATUSES[component.new_status].iconUrl;
  };

  const getDetails = () => {
    const id: any = "";
    let incidentsData: any = [];
    incidentsData = incidentsData
      .sort(
        (a, b) =>
          (new Date(a.start_time) as any) - (new Date(b.start_time) as any)
      )
      .map((eachInc) => ({
        iconUrl: getIconUrl(eachInc, id || ""),
        ...eachInc,
      }));
    return incidentsData || [];
  };

  const handleTabChange = (event, tab) => {
    setCurrentTab(parseInt(tab, 10));
    // setFilteredProductsData(products);
  };
  const handleIncidentTabChange = (event, tab) => {
    setCurrentIncidentTab(tab);
    // setFilteredProductsData(products);
  };
  const isMobile = useMediaQuery("(max-width: 992px)");
  const freshworksGrade = {
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(86.26deg, #B5FFD3 4.44%, #D1A4FF 30.65%, #FFA5AF 55.19%, #FFDCA4 79.42%),linear-gradient(86.26deg, #B5FFD3 4.44%, #D1A4FF 30.65%, #FFA5AF 45.93%, #FFDCA4 58.1%)",
    backgroundClip: "text",
    textFillColor: "transparent",
  };
  const setScheduledIncProdCount = (scheduledIncLength, prodName) => {
    setProdData(
      prodData.map((prod: any) => {
        if (prod.name === prodName)
          prod.currentScheduledIncLength = scheduledIncLength;
        return prod;
      })
    );
  };
  return (
    <Box>
      <Box>
        <Box sx={banner}>
          <Box>
            <Box>
              <Box sx={topBox}>
                <Box>
                  <a
                    href="https://freshworks.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://www.freshworks.com/static-assets/images/common/company/logos/logo-fworks-white.svg"
                      alt="Freshworks"
                      height={24}
                      width={120}
                    />
                  </a>
                </Box>
                <Box>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                    href="https://support.freshworks.com/en/support/home"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Support Portal
                  </Link>
                </Box>
              </Box>
            </Box>
            <Grid container sx={lPage} display="-webkit-box">
              <Grid item xs={12} md={12} lg={9}>
                <Box sx={welcome} py={3}>
                  Welcome to <Box sx={freshworksGrade}>Freshworks</Box> Status
                  Page
                  <span className="beta">Beta</span>
                </Box>

                <Box sx={looking} pt={1} pb={4}>
                  Track the real-time availability of our products and services
                  for a seamless user experience. Please reach out to our
                  support team for any assistance you may need.{" "}
                </Box>
              </Grid>
              {!isMobile && (
                <Grid item lg={3} sx={bannerImage}></Grid>
              )}
            </Grid>
          </Box>
        </Box>
        <Box sx={pullup}>
          <Box sx={lpageProducts}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              {isMobile ? (
                <Box>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Select
                      labelId="dropdown-label"
                      value={currentTab}
                      onChange={(e) => {
                        handleTabChange(e, e.target.value);
                      }}
                      className={classes.regionDropdown}
                    >
                      <MenuItem value="0">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          All Regions
                        </Box>
                      </MenuItem>
                      <MenuItem value="1">
                        {" "}
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          US
                        </Box>
                      </MenuItem>
                      <MenuItem value="2">
                        {" "}
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          Europe
                        </Box>
                      </MenuItem>
                      <MenuItem value="3">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          India
                        </Box>
                      </MenuItem>
                      <MenuItem value="4">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          Asia Pacific
                        </Box>
                      </MenuItem>
                    </Select>
                  </Box>
                  <Box>
                    <Tabs
                      className={classes.tab}
                      value={currentIncidentTab}
                      onChange={handleIncidentTabChange}
                      TabIndicatorProps={{ style: { display: "none" } }}
                    >
                      <Tab label="STATUS" value={"status"} />
                      <Tab label="MAINTENANCES" value={"maintenances"} />
                    </Tabs>
                  </Box>
                </Box>
              ) : (
                <Grid container>
                  <Grid item lg={10}>
                    <Tabs
                      className={classes.tab}
                      value={currentIncidentTab}
                      onChange={handleIncidentTabChange}
                      TabIndicatorProps={{ style: { display: "none" } }}
                    >
                      <Tab label="STATUS" value={"status"} />
                      <Tab label="MAINTENANCES" value={"maintenances"} />
                    </Tabs>
                  </Grid>
                  <Grid item lg={2} display="flex" justifyContent="flex-end">
                    <Select
                      labelId="dropdown-label"
                      value={currentTab}
                      onChange={(e) => {
                        handleTabChange(e, e.target.value);
                      }}
                      className={classes.regionDropdown}
                    >
                      <MenuItem value="0">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          All Regions
                        </Box>
                      </MenuItem>
                      <MenuItem value="1">
                        {" "}
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          US
                        </Box>
                      </MenuItem>
                      <MenuItem value="2">
                        {" "}
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          Europe
                        </Box>
                      </MenuItem>
                      <MenuItem value="3">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          India
                        </Box>
                      </MenuItem>
                      <MenuItem value="4">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          Asia Pacific
                        </Box>
                      </MenuItem>
                      <MenuItem value="5">
                        <Box display={"flex"} alignContent={"center"}>
                          <LocationIcon className={"location-icon"} />
                          Middle East
                        </Box>
                      </MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              )}
            </Box>
            {products.every((prod) => prod.status) ? (
              <Grid container justifyContent="flex-start">
                {products.every((prod) => prod.status) &&
                currentIncidentTab === "maintenances" &&
                showNoMaintenance ? (
                  <Box className="no-maintaince">
                    <img
                      src={`/icons/success.svg`}
                      height={24}
                      width={24}
                      alt={"All Good"}
                    />
                    There are no ongoing maintenance windows!
                  </Box>
                ) : (
                  products.every((prod) => prod.status) &&
                  products.map((object, i) => {
                    return (
                     ( currentIncidentTab !== 'maintenances' || (currentIncidentTab === 'maintenances' && object.scheduledInc.length > 0 ) ?
                      <Grid
                        key={i}
                        item
                        lg={12}
                        sx={prodCard}
                        md={12}
                        sm={12}
                        xs={12}
                      >
                        <ProductCard
                          data={object}
                          getDetails={getDetails}
                          currentTab={currentTab}
                          currentIncidentTab={currentIncidentTab}
                          componentsList={object.data.componentsList}
                          currentProductIndex={i}
                          totalProducts={products.length - 1}
                          setScheduledIncProdCount={setScheduledIncProdCount}
                        ></ProductCard>
                      </Grid> : null)
                    );
                  })
                )}
              </Grid>
            ) : (
              <Grid container justifyContent="flex-start">
                <Grid container justifyContent="flex-start">
                  {products.map((object, i) => {
                    return (
                      <Grid
                        key={i}
                        item
                        lg={12}
                        sx={prodCard}
                        md={12}
                        sm={12}
                        xs={12}
                      >
                        <ProductCardLoader
                          data={object}
                          getDetails={getDetails}
                          currentTab={currentTab}
                          currentIncidentTab={currentIncidentTab}
                          currentProductIndex={i}
                          totalProducts={products.length - 1}
                        ></ProductCardLoader>
                      </Grid>
  
                      
                    );
                  })}

            
                </Grid>
              </Grid>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
